module.exports = __webpack_public_path__ + "static/media/Hangman5.4f95f9fd.png";